export function isProbablyMaskedMobileNumber(value) {
  if (value === null || value === undefined) return false;
  const s = String(value).trim();
  if (!s) return false;

  // Common masking characters used by APIs/clients.
  if (s.includes("*") || s.includes("X") || s.includes("x")) return true;

  // If it contains non-dialable characters (besides +, space, -, parentheses),
  // treat it as masked/unsafe for tel: usage.
  const allowed = /^[0-9+\-\s()]+$/;
  return !allowed.test(s);
}

export function isDialableMobileNumber(value) {
  if (value === null || value === undefined) return false;
  const s = String(value).trim();
  if (!s) return false;
  if (isProbablyMaskedMobileNumber(s)) return false;
  const digits = s.replace(/\D/g, "");
  return digits.length >= 8;
}

